export default "__VITE_ASSET__CFUmaXMN__"